import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { HiChevronRight } from "react-icons/hi";
import { BsFillPersonFill } from "react-icons/bs";
import Searchbar from "./Searchbar";
import searchData from "../components/searchdata.json";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Mobile Navigation Component
const MobileNav = ({ 
  isOpen, 
  setIsOpen, 
  isaboutOpen, 
  setIsaboutOpen, 
  istrainingOpen, 
  setIstrainingOpen,
  openSubmenu,
  setOpenSubmenu 
}) => {
  const location = useLocation();

  const navLinksForHamburger = [
    { name: "SOI Projects", to: "https://www.surveyofindia.gov.in/pages/svamitva", external: true },
    { name: "Site Map", to: "/components/SiteMap/sitemap", external: false },
    { name: "Gallery", to: "/gallery", external: false },
    { name: "RTI", to: "/rti", external: false },
    { name: "E-Resources", to: "/project-report", external: false },
    { name: "Research & Development", to: "/research-development", external: false },
    { name: "NCVET Skill Development", to: "/ncvet", external: false },
    { name: "FAQ", to: "/components/FAQ/faq", external: false },
    { name: "Contact Us", to: "/Contactus", external: false },
  ];

  const aboutLinks = [
    { to: "/about/introduction", label: "Introduction", external: false },
    {
      label: "Governance Structure",
      submenu: [
        { to: "/about/governance/board_of_governance", label: "Board Of Governance" },
        { to: "/about/governance/board_of_evaluation", label: "Board Of Evaluation" },
        { to: "/about/governance/board_of_studies", label: "Board Of Studies" },
      ]
    },
    {
      label: "Faculty",
      submenu: [
        { to: "/faculty/geodesy", label: "Faculty of Geodesy" },
        { to: "/faculty/photogrammetry", label: "Faculty of P & RS" },
        { to: "/faculty/cartography", label: "Faculty of Topo & GIS" },
        { to: "/faculty/geo_ict", label: "Faculty of Geo-ICT" },
      ]
    },
    { to: "/about/nigst_campus", label: "NIGST Campus", external: false },
    { to: "/location", label: "Location", external: false },
    { label: "SOI Annual Reports", to: "https://www.surveyofindia.gov.in/pages/annual-reports", external: true },
    { label: "Raj Bhasha", to: "/components/rajbhasha/rajbhasha", external: false },
    { label: "Policies", to: "/components/geospatial", external: false },
  ];

  const trainingLinks = [
    { to: "/courses", label: "Courses" },
    { to: "/login", label: "Training Registration" },
    { to: "/feesandpayment", label: "Fee and Payment" },
    { to: "/hostel-info", label: "Accomodation facilities" }
  ];

  const getMenuName = (label) => {
    return label.toLowerCase().replace(/\s+/g, '_');
  };

  const handleAboutOpen = () => {
    setIsaboutOpen(!isaboutOpen);
    setIstrainingOpen(false);
  };

  const handletrainingToggle = () => {
    setIstrainingOpen(prev => !prev);
    setIsaboutOpen(false);
  };

  const handleSubmenuToggle = (menuName) => {
    setOpenSubmenu(openSubmenu === menuName ? null : menuName);
  };

  const closeAllMenus = () => {
    setIsOpen(false);
    setIsaboutOpen(false);
    setIstrainingOpen(false);
    setOpenSubmenu(null);
  };

  // Close menu when route changes
  useEffect(() => {
    closeAllMenus();
  }, [location]);

  return (
    <>
      {/* Mobile Header */}
      <div className="flex items-center justify-between w-full lg:hidden">
        <button 
          className="flex items-center px-3 py-2 rounded text-white hover:text-yellow-300"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <GiHamburgerMenu size="1.2em" />
        </button>

        <div className="flex items-center gap-3 ">
          <div className="flex-1 ">
            <Searchbar data={searchData} />
          </div>
          <div className="flex items-center">
            <Link to="/login" className="flex items-center justify-center p-1">
              <BsFillPersonFill size="1.3em" color="white" />
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 bg-[#1050A2] z-50 max-h-[80vh] overflow-y-auto lg:hidden">
          <div className="text-sm">
            {/* Home Link */}
            <Link
              to="/"
              className="block py-3 px-4 text-white hover:text-yellow-300 border-b border-white/10"
              onClick={closeAllMenus}
            >
              Home
            </Link>

            {/* About NIGST Section */}
            <div className="border-b border-white/10">
              <div 
                className="flex justify-between items-center py-3 px-4 text-white hover:text-yellow-300 cursor-pointer"
                onClick={handleAboutOpen}
              >
                <span>About NIGST</span>
                <HiChevronRight className={`h-5 w-5 transition-transform ${isaboutOpen ? "rotate-90" : ""}`} />
              </div>

              {/* About Dropdown */}
              {isaboutOpen && (
                <div className="bg-[#0c3d7a]">
                  {aboutLinks.map((item, index) => {
                    if (item.submenu) {
                      const menuName = getMenuName(item.label);
                      const isSubmenuOpen = openSubmenu === menuName;
                      
                      return (
                        <div key={index}>
                          <div 
                            className="flex items-center justify-between px-6 py-3 text-white hover:text-yellow-300 cursor-pointer border-b border-white/10"
                            onClick={() => handleSubmenuToggle(menuName)}
                          >
                            <span>{item.label}</span>
                            <HiChevronRight className={`h-4 w-4 transition-transform ${isSubmenuOpen ? "rotate-90" : ""}`} />
                          </div>
                          
                          {/* Submenu */}
                          {isSubmenuOpen && (
                            <div className="bg-[#1050A2]">
                              {item.submenu.map((sub, subIndex) => (
                                <Link
                                  key={subIndex}
                                  to={sub.to}
                                  className="block px-8 py-3 text-white hover:text-yellow-300 hover:bg-[#0c3d7a] border-b border-white/10"
                                  onClick={closeAllMenus}
                                  {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                  {sub.label}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <Link
                          key={index}
                          to={item.to}
                          className="block px-6 py-3 text-white hover:text-yellow-300 hover:bg-[#0c3d7a] border-b border-white/10"
                          onClick={closeAllMenus}
                          {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                          {item.label}
                        </Link>
                      );
                    }
                  })}
                </div>
              )}
            </div>

            {/* Training Section */}
            <div className="border-b border-white/10">
              <div 
                className="flex justify-between items-center py-3 px-4 text-white hover:text-yellow-300 cursor-pointer"
                onClick={handletrainingToggle}
              >
                <span>Training</span>
                <HiChevronRight className={`h-5 w-5 transition-transform ${istrainingOpen ? "rotate-90" : ""}`} />
              </div>

              {/* Training Dropdown */}
              {istrainingOpen && (
                <div className="bg-[#0c3d7a]">
                  {trainingLinks.map((item, index) => (
                    <Link
                      key={index}
                      to={item.to}
                      className="block px-6 py-3 text-white hover:text-yellow-300 hover:bg-[#1050A2] border-b border-white/10"
                      onClick={closeAllMenus}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Other Navigation Links */}
            {navLinksForHamburger.map((link, index) => (
              <Link
                key={index}
                to={link.to}
                className="block py-3 px-4 text-white hover:text-yellow-300 border-b border-white/10"
                onClick={closeAllMenus}
                {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              >
                {link.name}
              </Link>
            ))}

            {/* Mobile-only additional links */}
            <div className="py-2 border-t border-white/20">
              <div className="flex flex-col">
                <Link
                  to="/components/rajbhasha/rajbhasha"
                  className="py-3 px-4 text-white hover:text-yellow-300 border-b border-white/10"
                  onClick={closeAllMenus}
                >
                  Raj Bhasha
                </Link>
                <Link
                  to="/publicgrievances"
                  className="py-3 px-4 text-white hover:text-yellow-300"
                  onClick={closeAllMenus}
                >
                  Policies
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Desktop Navigation Component
const DesktopNav = () => {
  const [isaboutOpen, setIsaboutOpen] = useState(false);
  const [istrainingOpen, setIstrainingOpen] = useState(false);
  const [hoveredSubmenu, setHoveredSubmenu] = useState(null);

  const navLinksForHamburger = [
    { name: "SOI Projects", to: "https://www.surveyofindia.gov.in/pages/svamitva", external: true },
    { name: "Site Map", to: "/components/SiteMap/sitemap", external: false },
    { name: "Gallery", to: "/gallery", external: false },
    { name: "RTI", to: "/rti", external: false },
    { name: "E-Resources", to: "/project-report", external: false },
    { name: "Research & Development", to: "/research-development", external: false },
    { name: "NCVET Skill Development", to: "/ncvet", external: false },
    { name: "FAQ", to: "/components/FAQ/faq", external: false },
    { name: "Contact Us", to: "/Contactus", external: false },
  ];

  const aboutLinks = [
    { to: "/about/introduction", label: "Introduction", external: false },
    {
      label: "Governance Structure",
      submenu: [
        { to: "/about/governance/board_of_governance", label: "Board Of Governance" },  
        { to: "/about/governance/board_of_evaluation", label: "Board Of Evaluation" },
        { to: "/about/governance/board_of_studies", label: "Board Of Studies" },
      ]
    },
    {
      label: "Faculty",
      submenu: [
        { to: "/faculty/geodesy", label: "Faculty of Geodesy" },
        { to: "/faculty/photogrammetry", label: "Faculty of P & RS" },
        { to: "/faculty/cartography", label: "Faculty of Topo & GIS" },
        { to: "/faculty/geo_ict", label: "Faculty of Geo-ICT" },
      ]
    },
    { to: "/about/nigst_campus", label: "NIGST Campus", external: false },
    { to: "/location", label: "Location", external: false },
    { label: "SOI Annual Reports", to: "https://www.surveyofindia.gov.in/pages/annual-reports", external: true },
    { label: "Raj Bhasha", to: "/components/rajbhasha/rajbhasha", external: false },
    { label: "Policies", to: "/components/geospatial", external: false },
  ];

  const trainingLinks = [
    { to: "/courses", label: "Courses" },
    { to: "/login", label: "Training Registration" },
    { to: "/feesandpayment", label: "Fee and Payment" },
    { to: "/hostel-info", label: "Accomodation facilities" }
  ];

  const getMenuName = (label) => {
    return label.toLowerCase().replace(/\s+/g, '_');
  };

  const handleSubmenuHover = (menuName) => {
    setHoveredSubmenu(menuName);
  };

  const handleSubmenuHoverEnd = () => {
    setHoveredSubmenu(null);
  };

  return (
    <div className="hidden lg:flex lg:flex-col lg:w-full">
      {/* Main navigation row with wrapping support */}
      <div className="flex flex-wrap items-center w-full gap-x-4 gap-y-2">
        {/* Navigation Links Container */}
        <div className="flex flex-wrap items-center flex-1 gap-x-4 gap-y-2">
          {/* Home Link */}
          <Link
            to="/"
            className="py-2 text-white hover:text-yellow-300 text-base whitespace-nowrap"
          >
            Home
          </Link>

          {/* About NIGST Section */}
          <div 
            className="relative group"
            onMouseEnter={() => setIsaboutOpen(true)}
            onMouseLeave={() => setIsaboutOpen(false)}
          >
            <div className="py-2 text-white hover:text-yellow-300 text-base cursor-pointer whitespace-nowrap">
              About NIGST
            </div>

            {/* About Dropdown */}
            {(isaboutOpen || hoveredSubmenu) && (
              <div className="absolute left-0 top-full w-64 bg-[#1050A2] shadow-lg z-20">
                <div className="py-2">
                  {aboutLinks.map((item, index) => {
                    if (item.submenu) {
                      const menuName = getMenuName(item.label);
                      const isSubmenuOpen = hoveredSubmenu === menuName;
                      
                      return (
                        <div key={index} className="relative">
                          <div 
                            className="flex items-center justify-between px-4 py-2 text-white hover:text-yellow-300 cursor-pointer"
                            onMouseEnter={() => handleSubmenuHover(menuName)}
                            onMouseLeave={handleSubmenuHoverEnd}
                          >
                            <span>{item.label}</span>
                            <HiChevronRight className={`h-4 w-4 transition-transform ${isSubmenuOpen ? "rotate-90" : ""}`} />
                          </div>
                          
                          {/* Submenu */}
                          {isSubmenuOpen && (
                            <div 
                              className="absolute left-full top-0 w-64 bg-[#1050A2] shadow-lg z-30"
                              onMouseEnter={() => handleSubmenuHover(menuName)}
                              onMouseLeave={handleSubmenuHoverEnd}
                            >
                              {item.submenu.map((sub, subIndex) => (
                                <Link
                                  key={subIndex}
                                  to={sub.to}
                                  className="block px-4 py-2 text-white hover:text-yellow-300 hover:bg-[#0c3d7a]"
                                  {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                  {sub.label}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <Link
                          key={index}
                          to={item.to}
                          className="block px-4 py-2 text-white hover:text-yellow-300 hover:bg-[#0c3d7a]"
                          {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                          {item.label}
                        </Link>
                      );
                    }
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Training Section */}
          <div 
            className="relative group"
            onMouseEnter={() => setIstrainingOpen(true)}
            onMouseLeave={() => setIstrainingOpen(false)}
          >
            <div className="py-2 text-white hover:text-yellow-300 text-base cursor-pointer whitespace-nowrap">
              Training
            </div>

            {/* Training Dropdown */}
            {istrainingOpen && (
              <div className="absolute left-0 top-full w-64 bg-[#1050A2] shadow-lg z-20">
                <div className="py-2">
                  {trainingLinks.map((item, index) => (
                    <Link
                      key={index}
                      to={item.to}
                      className="block px-4 py-2 text-white hover:text-yellow-300 hover:bg-[#0c3d7a]"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Other Navigation Links */}
          {navLinksForHamburger.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="py-2 text-white hover:text-yellow-300 text-base whitespace-nowrap"
              {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              {link.name}
            </Link>
          ))}
        </div>

        {/* Searchbox for desktop */}
        <div className="flex items-center flex-shrink-0">
          <Searchbar data={searchData} />
        </div>
      </div>
    </div>
  );
};

// Main Navbar Component
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isaboutOpen, setIsaboutOpen] = useState(false);
  const [istrainingOpen, setIstrainingOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Close dropdowns when clicking outside (mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && isOpen && !event.target.closest('nav')) {
        setIsOpen(false);
        setIsaboutOpen(false);
        setIstrainingOpen(false);
        setOpenSubmenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobile, isOpen]);

  return (
    <nav className="flex items-start justify-between flex-wrap bg-[#1050A2] p-2 w-full cursor-pointer relative">
      {/* Mobile Navigation */}
      <MobileNav 
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isaboutOpen={isaboutOpen}
        setIsaboutOpen={setIsaboutOpen}
        istrainingOpen={istrainingOpen}
        setIstrainingOpen={setIstrainingOpen}
        openSubmenu={openSubmenu}
        setOpenSubmenu={setOpenSubmenu}
      />

      {/* Desktop Navigation */}
      <DesktopNav />
    </nav>
  );
};

export default Navbar;